import "./App.css";
import React from "react";
import Layout from "./components/Layout";
import { SolanaWallet } from "./components/solana/SolanaWallet";
import Performance from "./pages/Performance";
import Portfolio from "./pages/Portfolio";
import FindRates from "./pages/FindRates";
import Prospect from "./pages/Prospect";
import UserUpdater from "./store/user/UserUpdater";
import { Route, Routes } from "react-router-dom";
import MarketUpdater from "./store/market/MarketUpdater";

const Updaters = () => {
  return (
    <>
      <MarketUpdater />
      <UserUpdater />
    </>
  );
};

function App() {
  return (
    <SolanaWallet>
      <Updaters />
      <Layout>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/performance" element={<Performance />} />
          <Route path="/find_rates" element={<FindRates />} />
          <Route path="/prospect" element={<Prospect />} />
        </Routes>
      </Layout>
    </SolanaWallet>
  );
}

export default App;
